import React from 'react';
import Chart from "react-apexcharts";


const data = {
          
  series: [{
    name: "Voltage",
    data:  [
        {
          x: "02-10-2017 06:00",
          y: 44
        },
        {
          x: "02-10-2017 07:30",
          y: 49
        },
        
        {
          x: "02-10-2017 07:35",
          y: 50
        },
        {
          x: "02-10-2017 08:00",
          y: 51
        },
        {
          x: "02-10-2017 09:10",
          y: 63
        },
        {
          x: "02-10-2017 10:55",
          y: 43
        },
        {
          x: "02-10-2017 11:48",
          y: 52
        },
        {
          x: "02-10-2017 13:10",
          y: 46
        },
        {
          x: "02-10-2017 14:55",
          y: 33
        },
        {
          x: "02-10-2017 15:48",
          y: 52
        },
        {
          x: "02-10-2017 16:30",
          y: 43
        },
        {
          x: "02-10-2017 17:55",
          y: 48
        },
        {
          x: "02-10-2017 18:48",
          y: 52
        },
        {
          x: "02-10-2017 19:30",
          y: 43
        },
        {
          x: "02-10-2017 20:55",
          y: 56
        },
        {
          x: "02-10-2017 21:48",
          y: 52
        },
        {
          x: "02-11-2017 01:00",
          y: 34
        },
        {
          x: "02-11-2017 03:30",
          y: 40
        },
        {
          x: "02-11-2017 04:35",
          y: 51
        },
        {
          x: "02-11-2017 05:10",
          y: 45
        },
        {
          x: "02-11-2017 06:55",
          y: 57
        },
        {
          x: "02-11-2017 07:48",
          y: 42
        }
   
      ]
  }],
  options: {
    chart: {
      id: 'area-datetime',
      type: 'area',
      height: 350,
      toolbar: { show: false },
      zoom: {
        enabled: false
      }
    },

    grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
    
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 0,
    },
    xaxis: {
      type: 'datetime',
      min: new Date('10 Feb 2017  06:00').getTime(),
      //tickAmount: 6,
      labels: {
        datetimeUTC: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      tooltip: {
        enabled: false
      },
      labels: {
        show: false},
      
      
    },
    tooltip: {
      x: {
        format: 'dd MMM yyyy HH:mm'
      }
    },colors: ["#cccccc"],
    fill: {
        type: 'gradient',
        gradient: {
          opacityFrom: 0.5,
          opacityTo: 0.5,
        }
      },
    stroke: {
      width: [1],
      curve: 'smooth',
    },
    yaxis: {
        show: false
      }




  },



  selection: 'one_year',

};



//Chart.register(CategoryScale);



function ApexLinePlant(){



    return (
       
        <>
      

          <Chart
        options={data.options}
        series={data.series}
        type="area"
        height={250}
        style={{margin:"-31px", marginLeft:"-32px", marginBottom:"-50px", marginRight:"-30px"}}
      />

       



        </>
    )
}

export default ApexLinePlant;



